export const APP_VERSION = { value: '2.0.3', date: '18.09.2026' }
